// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 4,
  argument: "A further exhortation to seek after wisdom.",
  verses: [
    { n: 1, text: "Hear, ye children, the instruction of a father, and attend, that you may know prudence." },
    { n: 2, text: "I will give you a good gift, forsake not my law." },
    { n: 3, text: "For I also was my father's son, tender, and as an only son in the sight of my mother:" },
    { n: 4, text: "And he taught me, and said: Let thy heart receive my words, keep my commandments, and thou shalt live." },
    { n: 5, text: "Get wisdom, get prudence: forget not, neither decline from the words of my mouth." },
    { n: 6, text: "Forsake her not, and she shall keep thee: love her, and she shall preserve thee." },
    { n: 7, text: "The beginning of wisdom, get wisdom, and with all thy possession purchase prudence." },
    { n: 8, text: "Take hold on her, and she shall exalt thee: thou shalt be glorified by her, when thou shalt embrace her." },
    { n: 9, text: "She shall give to thy head increase of graces, and protect thee with a noble crown." },
    { n: 10, text: "Hear, O my son, and receive my words, that years of life may be multiplied to thee." },
    { n: 11, text: "I will shew thee the way of wisdom, I will lead thee by the paths of equity:" },
    { n: 12, text: "Which when thou shalt have entered, thy steps shall not be straitened, and when thou runnest, thou shalt not meet a stumbling-block." },
    { n: 13, text: "Take hold on instruction, leave it not: keep it, because it is thy life." },
    { n: 14, text: "Be not delighted in the paths of the wicked, neither let the way of evil men please thee." },
    { n: 15, text: "Flee from it, pass not by it: go aside, and forsake it." },
    { n: 16, text: "For they sleep not, except they have done evil: and their sleep is taken away unless they have made some to fall." },
    { n: 17, text: "They eat the bread of wickedness, and drink the wine of iniquity." },
    { n: 18, text: "But the path of the just, as a shining light, goeth forwards, and increaseth even to perfect day." },
    { n: 19, text: "The way of the wicked is darksome: they know not where they fall." },
    { n: 20, text: "My son, hearken to my words, and incline thy ear to my sayings." },
    { n: 21, text: "Let them not depart from thy eyes, keep them in the midst of thy heart:" },
    { n: 22, text: "For they are life to those that find them, and health to all flesh." },
    { n: 23, text: "With all watchfulness keep thy heart, because life issueth out from it." },
    { n: 24, text: "Remove from thee a froward mouth, and let detracting lips be far from thee." },
    { n: 25, text: "Let thy eyes look straight on, and let thy eye-lids go before thy steps." },
    { n: 26, text: "Make straight the path for thy feet, and all thy ways shall be established." },
    { n: 27, text: "Decline not to the right hand, nor to the left: turn away thy foot from evil. For the Lord knoweth the ways that are on the right hand: but those are perverse which are on the left hand. But he will make thy courses straight, he will bring forward thy ways in peace." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Father. He shews the greatest respect for his parents,", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "He. Hebrew is masculine. (Calmet) — As David instructed his son, so the latter teaches all how they may learn wisdom.", attribution: "Worthington" }
    ] },
    { verse: 7, notes: [
      { text: "Beginning. The first part of wisdom is to desire it. For nothing hindereth from being just, but that justice is not desired. (St. Augustine, in Psalm cxviii. 20.) (Worthington) — \"Wisdom is the principal thing; therefore get,\" &c. (Protestants) (Haydock) — It is the one thing necessary. (Calmet) — The pearl, to acquire which we must part with every thing else, if required, Matthew xiii. 46.", attribution: "Menochius" }
    ] },
    { verse: 17, notes: [
      { text: "Wickedness. Acquired thereby, or they make sin their food, chap. xxvi. 6.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Day. They are children of light, (John xii. 35.) and give edification, always advancing in virtue.", attribution: "Menochius" }
    ] },
    { verse: 19, notes: [
      { text: "Fall. They are unconcerned about sin, and neither avoid it, nor strive to repent.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "Flesh. All may derive benefit from their consideration.", attribution: "Haydock" }
    ] },
    { verse: 23, notes: [
      { text: "From it. As the heart is the principal part of the body, so the will is the chief power of the soul, from which good or evil proceeds. (Worthington) — A clean heart gives life, a corrupt one, death, Matthew xv. 11, 19.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "From thee. Neither detract, nor give any countenance to detractors.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Steps. Be attentive to thy own affairs, Proverbs xvii. 24.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Straight. Hebrew, \"ponder.\" Examine what thou takest in hand, and walk not at random, Hebrews xii. 13.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "For, &c. What follows in not in Hebrew or the Complutensian (Calmet) Septuagint. But it is in the Roman [Septuagint], &c., (Haydock) and in the new edition of St. Jerome, as it was explained by Ven. Bede. Lyranus and Cajetan reject it.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
